module.exports = __webpack_public_path__ + "img/HANHUA-FPD-detail.00762756.png";